import { useAuth0 } from '@auth0/auth0-react';
import { Button } from 'react-bootstrap';

function LogoutButton() {
	const { isAuthenticated, logout } = useAuth0();

	return (
		isAuthenticated && (
			<Button
				onClick={() => {
					logout({ returnTo: window.location.origin });
				}}
				variant='danger'
			>
				Logout
			</Button>
		)
	);
}
export default LogoutButton;
